module.exports = __webpack_public_path__ + "static/wallet-icon-0c32ab665864be596f20decd5b5e42c2.png";